import React from 'react';
import { useTranslation } from 'react-i18next';
import { MailTwoTone, PhoneTwoTone } from '@ant-design/icons';
import { Divider } from 'antd';
import { ContactWrapper } from './Contact.styled';
import { Text, FlexDivCenter } from '../../components/Typography/Typography';
import { getWeboConfig } from '../../utils';

export default () => {
  const { t } = useTranslation();
  return (
    <ContactWrapper className="animate__animated animate__fadeIn">
      <FlexDivCenter>
        <div
          style={{
            background: 'white',
            margin: '30px 0',
            border: '1px solid #1D3E7E',
            boxShadow: '-1px -2px 16px -5px rgba(0,0,0,0.83)',
            width: 400,
            padding: 10,
            borderRadius: 3,
          }}
        >
          <Text bold size="xxlarge">
            {t('contact_us')}
          </Text>
          <Text size="large">{t('contact_us_description')}</Text>
        </div>
      </FlexDivCenter>
      <FlexDivCenter>
        <div style={{ width: 400 }}>
          <Divider style={{ background: '#fff' }} />
        </div>
      </FlexDivCenter>
      <FlexDivCenter>
        <Text color="#FFF" size="large" margin="0 10">
          <a
            style={{ color: '#FFF' }}
            href={`mailto:${getWeboConfig('STORE_SUPPORT_EMAIL')}`}
          >
            {getWeboConfig('STORE_SUPPORT_EMAIL')}
          </a>
        </Text>
        <MailTwoTone style={{ fontSize: 24 }} />
      </FlexDivCenter>
      <FlexDivCenter>
        <div style={{ width: 400 }}>
          <Divider style={{ background: '#fff' }} />
        </div>
      </FlexDivCenter>

      <FlexDivCenter>
        <Text color="#FFF" size="large" margin="0 10">
          <a
            style={{ color: '#FFF' }}
            href={`tel:+${getWeboConfig('STORE_SUPPORT_PHONE').replace(
              '0',
              '972'
            )}`}
          >
            {getWeboConfig('STORE_SUPPORT_PHONE') || ''}
          </a>
        </Text>
        <PhoneTwoTone style={{ fontSize: 24 }} />
      </FlexDivCenter>

      <FlexDivCenter>
        <div style={{ width: 400 }}>
          <Divider style={{ background: '#fff' }} />
        </div>
      </FlexDivCenter>
      <FlexDivCenter>
        <FlexDivCenter
          style={{
            height: 250,
            width: 250,
            border: '1px solid #f0f0f0;',
            marginBottom: 15,
          }}
        />
      </FlexDivCenter>
    </ContactWrapper>
  );
};
